import { render, staticRenderFns } from "./Specifiche.vue?vue&type=template&id=44c9ad74&"
import script from "./Specifiche.vue?vue&type=script&lang=js&"
export * from "./Specifiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports